import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

// Filet de sécurité global : évite la page blanche si un composant crash au rendu.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Erreur de rendu non gérée :', error, errorInfo.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='min-h-screen bg-gray-50 dark:bg-dark-50 flex items-center justify-center p-6'>
          <div className='max-w-md text-center space-y-4'>
            <div className='text-5xl'>⚠️</div>
            <h1 className='text-xl font-semibold text-gray-900 dark:text-white'>
              Une erreur inattendue est survenue
            </h1>
            <p className='text-gray-500 dark:text-gray-400 text-sm'>
              L'application a rencontré un problème. Vos données ne sont pas perdues —
              rechargez la page pour continuer.
            </p>
            <button
              onClick={this.handleReload}
              className='px-5 py-2.5 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors'
            >
              Recharger la page
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
